import { UIDataModel, UIComponentHandler, UIComponentProps, UIComponentState } from "./uicomponent";
import * as React from "react";
import { UIComponentCSSStyle } from "./uicomponentcss";
import { BaseContext } from '../../utils/basecontext';

export interface UIComponentView<T extends UIDataModel> 
{
    bindHandlers(): void;
    draw(uiProps: UIComponentProps, uiState: UIComponentState, cssStyle: UIComponentCSSStyle): JSX.Element | boolean;
    getData(): T;
    clearData(): void;
    validate(): boolean;
}

export class UIComponentViewImpl<T extends UIDataModel> implements UIComponentView<T>
{
    private uiProps: UIComponentProps;
    private uiState: UIComponentState;
    private cssStyle: UIComponentCSSStyle;
    
    constructor(private applicationContext: BaseContext, private uiComponentHandler: UIComponentHandler)
    {
        
    }

    draw(uiProps: UIComponentProps, uiState: UIComponentState, cssStyle: UIComponentCSSStyle): JSX.Element | boolean
    {
        this.uiProps = uiProps;
        this.uiState = uiState;
        this.cssStyle = cssStyle;

        return <div/>;
    }

    setUIObjects(uiProps: UIComponentProps, uiState: UIComponentState, cssStyle: UIComponentCSSStyle){
        this.uiProps = uiProps;
        this.uiState = uiState;
        this.cssStyle = cssStyle;
    }

    getData(): T 
    {
        throw new Error("Method not implemented.");
    }

    clearData(): void 
    {
        
    }

    validate(): boolean 
    {
        return true;
    }

    bindHandlers()
    {
        
    }

    protected getUIComponentHandler(): UIComponentHandler
    {
        return this.uiComponentHandler;
    }

    protected getContext(): BaseContext
    {
        return this.applicationContext;
    }

    protected getUIProps(): UIComponentProps
    {
        return this.uiProps;
    }

    protected getUIState(): UIComponentState
    {
        return this.uiState;
    }

    protected getUICSSStyle(): UIComponentCSSStyle
    {
        return this.cssStyle;
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/uicomponentview.tsx